export const FONT_FAMILY = {
  "FontFamily.Name": {
    defaultValue: "Inter"
  },
  "FontFamily.Regular.URL": {},
  "FontFamily.Thin.URL": {},
  "FontFamily.Bold.URL": {}
};
